// extracted by mini-css-extract-plugin
export var chevron = "_bf-2";
export var dropdownItems = "_bf-0";
export var item = "_bf-1";